import React from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyPolicyPage.css';

export default function PrivacyPolicyPage() {
    const { t } = useTranslation();

    return (
        <div className="privacy-policy-page-container">
            <h1>{t('privacyPolicy.title')}</h1>
            <p className="last-updated">{t('privacyPolicy.lastUpdated')}</p>

            <section>
                {t('privacyPolicy.intro', { returnObjects: true, defaultValue: [] }).map((p, index) => (
                    <p key={index} dangerouslySetInnerHTML={{ __html: p }} />
                ))}
            </section>
            
            {/* Section 1: Terminology */}
            <section>
                <h2>{t('privacyPolicy.section1.title')}</h2>
                <p>{t('privacyPolicy.section1.intro')}</p>
                <ol>
                    {t('privacyPolicy.section1.terms', { returnObjects: true, defaultValue: [] }).map((term, index) => (
                        <li key={index}>
                            <strong>{term.title}</strong> - <span dangerouslySetInnerHTML={{ __html: term.definition }} />
                        </li>
                    ))}
                </ol>
            </section>
            
            {/* Section 2: User Consent */}
            <section>
                <h2>{t('privacyPolicy.section2.title')}</h2>
                <ol>
                    {t('privacyPolicy.section2.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index}>
                            <p dangerouslySetInnerHTML={{ __html: point.text }} />
                            {point.subpoints && (
                                <ol className="sub-points">
                                    {point.subpoints.map((subpoint, subIndex) => (
                                        <li key={subIndex}>
                                            <p dangerouslySetInnerHTML={{ __html: subpoint }} />
                                        </li>
                                    ))}
                                </ol>
                            )}
                        </li>
                    ))}
                </ol>
            </section>

            {/* Section 3: User Data Provision */}
            <section>
                <h2>{t('privacyPolicy.section3.title')}</h2>
                <p>{t('privacyPolicy.section3.intro')}</p>
                <ol>
                    {t('privacyPolicy.section3.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                </ol>
            </section>

            {/* Section 4: Data Processed */}
            <section>
                <h2>{t('privacyPolicy.section4.title')}</h2>
                <ol>
                    {t('privacyPolicy.section4.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                </ol>
            </section>

            {/* Section 5: Cookies */}
            <section>
                <h2>{t('privacyPolicy.section5.title')}</h2>
                <ol>
                    {t('privacyPolicy.section5.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index}>
                            <p dangerouslySetInnerHTML={{ __html: point.text }} />
                            {point.subpoints && (
                                <ul>
                                    {point.subpoints.map((subpoint, subIndex) => (
                                        <li key={subIndex}>
                                            <p><strong>{subpoint.title}</strong> - {subpoint.text}</p>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {point.outro && <p dangerouslySetInnerHTML={{ __html: point.outro }} />}
                        </li>
                    ))}
                </ol>
            </section>
            
            {/* Section 6: Processing Goals */}
             <section>
                <h2>{t('privacyPolicy.section6.title')}</h2>
                <p>{t('privacyPolicy.section6.intro')}</p>
                <ol>
                    {t('privacyPolicy.section6.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                </ol>
            </section>

            {/* Section 7: Data Processing */}
             <section>
                <h2>{t('privacyPolicy.section7.title')}</h2>
                <ol>
                    {t('privacyPolicy.section7.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                         <li key={index}>
                            <p dangerouslySetInnerHTML={{ __html: point.text }} />
                            {point.subpoints && (
                                <ol className="sub-points">
                                    {point.subpoints.map((subpoint, subIndex) => (
                                        <li key={subIndex}>
                                            <p dangerouslySetInnerHTML={{ __html: subpoint }} />
                                        </li>
                                    ))}
                                </ol>
                            )}
                        </li>
                    ))}
                </ol>
            </section>

            {/* Section 8: Data Protection */}
            <section>
                <h2>{t('privacyPolicy.section8.title')}</h2>
                {t('privacyPolicy.section8.paragraphs', { returnObjects: true, defaultValue: [] }).map((p, index) => (
                    <p key={index} dangerouslySetInnerHTML={{ __html: p }} />
                ))}
            </section>

            {/* Section 9: User Rights */}
            <section>
                <h2>{t('privacyPolicy.section9.title')}</h2>
                <p>{t('privacyPolicy.section9.intro')}</p>
                <ol>
                    {t('privacyPolicy.section9.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                </ol>
            </section>
            
            {/* Section 10: Policy Changes */}
            <section>
                <h2>{t('privacyPolicy.section10.title')}</h2>
                <ol>
                    {t('privacyPolicy.section10.points', { returnObjects: true, defaultValue: [] }).map((point, index) => (
                        <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                </ol>
            </section>

            {/* Section 11: Seller */}
            <section>
                <h2>{t('privacyPolicy.section11.title')}</h2>
                {t('privacyPolicy.section11.details', { returnObjects: true, defaultValue: [] }).map((detail, index) => (
                    <p key={index} dangerouslySetInnerHTML={{ __html: detail }} />
                ))}
            </section>
        </div>
    );
} 